<template>
    <div class="no-login"></div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'NoLogin',
  components: {
  },
  mounted() {
    // set store "noLogin" to true
    this.setNoLoginOn()
    this.$router.replace("/")
  },
  methods: {
    ...mapActions({
      setNoLoginOn: 'noLogin/setNoLoginOn',
      // setNoLoginOff: 'noLogin/setNoLoginOff',
    }),
  }
}
</script>

<style lang="scss" scoped>
</style>
